import {
	getCompletedByDisplayName,
	getHistoryPerformerDisplayName
} from "./sharedTaskIdentityUtils";

function isObject(value) {
	return !!value && typeof value === "object";
}

function cloneForReport(value, activity, inHistory, isHistoryEntry, seen) {
	if (!isObject(value)) {
		return value;
	}

	if (seen.has(value)) {
		return seen.get(value);
	}

	if (value instanceof Date) {
		return new Date(value.getTime());
	}

	if (Array.isArray(value)) {
		const result = [];
		seen.set(value, result);
		value.forEach(entry => result.push(cloneForReport(entry, activity, inHistory, isHistoryEntry, seen)));
		return result;
	}

	const result = {};
	seen.set(value, result);
	Object.keys(value).forEach(key => {
		const isHistoryCollection = key === "history";
		result[key] = cloneForReport(
			value[key],
			activity,
			inHistory || isHistoryCollection,
			isHistoryCollection,
			seen
		);
	});

	const itemType = typeof value.type === "string" ? value.type.trim().toLowerCase() : "";
	if (!inHistory && itemType.startsWith("item") && itemType !== "itemcontainer") {
		result.completedByDisplayName = getCompletedByDisplayName(activity, value, {
			allowIdentifierFallback: false
		});
	}

	if (isHistoryEntry) {
		result.performedByDisplayName = getHistoryPerformerDisplayName(value, {
			allowIdentifierFallback: false
		});
	}

	return result;
}

/**
 * Adds stable display-only attribution fields to an activity report payload.
 * The persisted activity and its answer values are never mutated or replaced.
 */
export function prepareSharedTaskIdentityReportFields(activity = {}) {
	if (!isObject(activity)) {
		return activity;
	}

	return cloneForReport(activity, activity, false, false, new WeakMap());
}
